import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/sub-retention")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "39d8dae2-ac4e-5913-a884-41258a936ee1" }, replace: true });
  },
  component: () => null,
});
